import ErrorMessage from 'components/ErrorMessage';
import React, { useState } from 'react';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import helper from 'utils/helpers';

const OInputField = (props) => {
  const {
    wrapperClassName,
    preventDecimal,
    name,
    inputLabel,
    type,
    onInput,
    step,
    placeholder,
    maxLength = 256,
    register,
    disabled,
    errors,
    requiredMark,
    ...rest
  } = props;

  const [showPassword, setShowPassword] = useState(false);

  switch (type) {
    case 'hidden':
      return (
        <input type={type} name={name} id={name} {...register} {...rest} />
      );
    case 'text':
    case 'number':
    case 'date':
      return (
        <div
          className={
            wrapperClassName
              ? wrapperClassName
              : 'relative z-0 mb-6 w-full group'
          }
        >
          <label
            htmlFor={name}
            className="block mb-2 text-sm  font-bold text-black dark:text-white"
          >
            {inputLabel} {requiredMark ? <span className="text-red-600">*</span> : null}
          </label>
          <input
            type={type}
            step={step}
            name={name}
            id={name}
            onInput={onInput}
            className="bg-gray-0 border border-[#F2F3F5] text-[#000] text-sm rounded-[6px]   block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder={placeholder ? placeholder : ' '}
            maxLength={maxLength}
            disabled={disabled}
            onChange={preventDecimal ? helper.preventDecimal : ''}
            {...register}
            {...rest}
          />

          <ErrorMessage message={errors?.[name]?.message} />
        </div>
      );
    case 'password':
      return (
        <div
          className={
            wrapperClassName
              ? wrapperClassName
              : 'relative z-0 mb-6 w-full group'
          }
        >
          <label
            htmlFor={name}
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            {inputLabel} {requiredMark ? <span className="text-red-600">*</span> : null}
          </label>
          <div className="relative">
            <input
              name={name}
              id={name}
              type={showPassword ? 'text' : 'password'}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder={placeholder ? placeholder : ' '}
              maxLength={maxLength}
              {...register}
              {...rest}
            />
            <div
              onClick={() => setShowPassword((prev) => !prev)}
              className="absolute right-[15px] bottom-[12px]"
            >
              {showPassword ? <AiFillEye /> : <AiFillEyeInvisible />}
            </div>
          </div>

          <ErrorMessage message={errors?.[name]?.message} />
        </div>
      );
    case 'email':
      return (
        <div
          className={
            wrapperClassName
              ? wrapperClassName
              : 'relative z-0 mb-6 w-full group'
          }
        >
          <label
            htmlFor={name}
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            {inputLabel} {requiredMark ? <span className="text-red-600">*</span> : null}
          </label>
          <input
            type={type}
            name={name}
            id={name}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder={placeholder ? placeholder : ' '}
            maxLength={maxLength}
            {...register}
            {...rest}
          />

          <ErrorMessage message={errors?.[name]?.message} />
        </div>
      );

    default:
      return <div>Please provide some input props.</div>;
  }
};

export default OInputField;
